import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { RotaFugaDBService } from '../database/rota-fuga-db.service';

@Injectable({
  providedIn: 'root'
})
export class RotaFugaService extends BaseService{
    public override route: string = 'rota-fuga';
    override classname: string = 'RotaFugaService';
    public override database = new RotaFugaDBService();
}
